import React from 'react';

const breakDoc = (
  <>
    <p>Triggers entry tactics on a break through a price.</p>
    <p>
      Ex: If AAPL is currently at 449, we can buy on a break of 450. If AAPL is
      currently at 451, we can short on a break at 450.
    </p>
    <p>
      NOTE: we attempt to validate the sensibility of the break, by terminating
      the trade plan if the break has already passed. For example, if you try to
      go long on a break at 450 when AAPL is at 451, the trade plan will be
      cancelled.
    </p>
  </>
);
export default breakDoc;
